import moment from 'moment'
import { Attachment as AttachmentType } from '../../../@types/GetQuotation'
import { ENV } from '../../../Environment'
import { useGetQuotationStore } from '../../../Stores/useGetQuotationStore'
import { DownloadIcon } from '../../Icons'
import { useDownloadDocuments } from '../../SimulationReport/useDownloadDocuments'
import { Row } from '../Row'
import { TabPageContainer } from '../styles'

type AttachmentProps = {
  keyRef: string | null
} & AttachmentType

export const Attachment = () => {
  const { getQuotation } = useGetQuotationStore()
  const { downloadFileQuotation, downloadFileCommon } = useDownloadDocuments()

  const handleDownloadFile = (attachment: AttachmentProps) => {
    if (attachment.keyRef) {
      downloadFileCommon({
        documentName: attachment.documentName,
        documentExternalId: attachment.idExternal,
        managementSystemCode: ENV().DOC1,
        keyRef: attachment.keyRef,
      })
    } else {
      downloadFileQuotation(attachment)
    }
  }

  return (
    <>
      <TabPageContainer>
        {getQuotation?.policyQuotation?.attachments?.map((attachment) => (
          <Row
            alignCenter
            dateTime={
              moment(attachment.date).format('DD-MM-YYYY HH[h]mm') || ''
            }
            rightContent={
              <div className="link">
                <p
                  className="text text-link"
                  onClick={() =>
                    handleDownloadFile(attachment as AttachmentProps)
                  }
                >
                  {attachment.documentName}
                </p>
                <p
                  className="text text-link"
                  onClick={() =>
                    handleDownloadFile(attachment as AttachmentProps)
                  }
                >
                  <DownloadIcon width={24} height={24} />
                </p>
              </div>
            }
          />
        ))}
      </TabPageContainer>
    </>
  )
}
